import { CardInputsContainer } from "~/common/components";
import { SettingsOutletLayout } from "~/providers/components/providerSettings/SettingsOutletLayout";
import { AddDocumentModal } from "~/providers/components/tools/AddDocumentModal";
import { ConsentDocumentsTable } from "~/providers/components/tools/ConsentDocumentsTable";
import { SchedulingMethods } from "~/providers/components/tools/SchedulingMethods";
import { useCurrentTeamMemberContext } from "~/providers/hooks";
import { useListConsentDocuments } from "~/providers/hooks/useListConsentDocuments";

export const GeneralScreen = () => {
  const currentTeamMember = useCurrentTeamMemberContext();
  const { data: consentDocuments } = useListConsentDocuments(
    currentTeamMember.organization_team_members[0].organization_id,
  );

  return (
    <SettingsOutletLayout>
      <SchedulingMethods />
      <CardInputsContainer title="Consent forms">
        <div className="flex flex-col gap-6">
          <div className="flex flex-col gap-4">
            <p className="text-sm">
              If you have specific terms of service (e.g. Informed consent or
              other disclosures) that you would like new patients to acknowledge
              and agree to as part of the consultation process, you can upload
              them here.
            </p>
            <p className="text-sm">
              Patients will be required to review and agree to the terms of
              service in these documents before they can begin the intake
              portion of the consultation.
            </p>
          </div>

          <div className="flex flex-col gap-4">
            <AddDocumentModal />
            {!!consentDocuments?.length && (
              <ConsentDocumentsTable documents={consentDocuments} />
            )}
          </div>
        </div>
      </CardInputsContainer>
    </SettingsOutletLayout>
  );
};
